import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_FETCH_SC_IN_ACTION_DATA_BEGIN,
  REPORTS_FETCH_SC_IN_ACTION_DATA_SUCCESS,
  REPORTS_FETCH_SC_IN_ACTION_DATA_FAILURE,
  REPORTS_FETCH_SC_IN_ACTION_DATA_DISMISS_ERROR,
} from './constants';

export function fetchScInActionData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_SC_IN_ACTION_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/getScInActionReport`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_SC_IN_ACTION_DATA_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              summary: res.data && res.data.summary
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_SC_IN_ACTION_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchScInActionDataError() {
  return {
    type: REPORTS_FETCH_SC_IN_ACTION_DATA_DISMISS_ERROR,
  };
}

export function useFetchScInActionData() {
  const dispatch = useDispatch();

  const { reportsData, summary,fetchScInActionDataPending, fetchScInActionDataError } = useSelector(
    state => ({
      reportsData: state.reports.reportsData,
      summary: state.reports.summary,
      fetchScInActionDataPending: state.reports.fetchScInActionDataPending,
      fetchScInActionDataError: state.reports.fetchScInActionDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchScInActionData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchScInActionDataError());
  }, [dispatch]);

  return {
    reportsData,
    summary,
    fetchScInActionData: boundAction,
    fetchScInActionDataPending,
    fetchScInActionDataError,
    dismissFetchScInActionDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_SC_IN_ACTION_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchScInActionDataPending: true,
        fetchScInActionDataError: null,
      };

    case REPORTS_FETCH_SC_IN_ACTION_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsData: action.data.data,
        reportsTotals: action.data.totals,
        summary: action.data.summary, 
        fetchScInActionDataPending: false,
        fetchScInActionDataError: null,
      };

    case REPORTS_FETCH_SC_IN_ACTION_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchScInActionDataPending: false,
        fetchScInActionDataError: action.data.error,
      };

    case REPORTS_FETCH_SC_IN_ACTION_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchScInActionDataError: null,
      };

    default:
      return state;
  }
}
